import crossIcon from '@/assets/icons/crossIcon.svg';
import searchIcon from '@/assets/icons/search.svg';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface SearchInputProps {
  onChange: (value: string) => void;
  placeholder?: string;
  value: string;
}

export function SearchInput({ onChange, placeholder = 'Search', value }: SearchInputProps) {
  const hasValue = value.trim().length > 0;

  const handleClear = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onChange('');
  };

  return (
    <div className="relative w-full">
      <Input
        className="bg-back-bg h-[28px] w-full gap-3 rounded-md border-[0.5px] pt-1.5 pr-9 pb-1.5 pl-3"
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        type="text"
        value={value}
      />
      <div className="absolute top-1/2 right-3 -translate-y-1/2">
        {hasValue ? (
          <Button
            aria-label="Clear search"
            className="!hover:bg-transparent flex h-auto w-auto cursor-pointer items-center justify-center border-0 !bg-transparent p-0 shadow-none transition-opacity hover:opacity-70"
            onClick={handleClear}
            size="icon"
            style={{ marginRight: '-2px' }}
            type="button"
            variant="ghost"
          >
            <img alt="Clear" className="icon-themed h-7 w-7 cursor-pointer" src={crossIcon} />
          </Button>
        ) : (
          <img
            alt="Search"
            className="icon-themed pointer-events-none h-3 w-3 cursor-pointer"
            src={searchIcon}
          />
        )}
      </div>
    </div>
  );
}
